<template>
  <div class="row justify-content-center">
    <div class="col-12 col-md-11 col-sm-12 col-xs-12">
      <GrupoList />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import GrupoList from "../../../../_shared/features/GrupoList.vue";

export default {
  name: "GruposAdmin",
  components: { GrupoList },
  data() {
    return {};
  },
  methods: {},
};
</script>
